import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6c0196fc")

_pushScopeId("data-v-6c0196fc")
const _hoisted_1 = { class: "kn-list-item-text" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_Listbox = _resolveComponent("Listbox")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary" }, {
      start: _withId(() => [
        _createTextVNode(_toDisplayString(_ctx.header), 1)
      ]),
      end: _withId(() => [
        _createVNode("i", {
          class: _ctx.iconClass,
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.sortArray && _ctx.sortArray(...args))),
          "data-test": "sort-icon"
        }, null, 2)
      ]),
      _: 1
    }),
    _createVNode(_component_Listbox, {
      class: "kn-list kn-flex",
      options: _ctx.filters,
      listStyle: _ctx.metadataDefinitionTabViewDescriptor.listBox.style,
      filter: true,
      filterPlaceholder: _ctx.$t('common.search'),
      optionLabel: "name",
      filterMatchMode: "contains",
      filterFields: _ctx.metadataDefinitionTabViewDescriptor.aliasFilterFields,
      emptyFilterMessage: _ctx.$t('common.info.noDataFound'),
      onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('selected', { value: $event.value.name, type: _ctx.listType })))
    }, {
      empty: _withId(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('common.info.noDataFound')), 1)
      ]),
      option: _withId((slotProps) => [
        _createVNode("div", {
          class: "kn-list-item",
          "data-test": 'list-item-' + slotProps.option.id
        }, [
          _createVNode("div", _hoisted_1, [
            _createVNode("span", null, _toDisplayString(slotProps.option.name), 1)
          ])
        ], 8, ["data-test"])
      ]),
      _: 1
    }, 8, ["options", "listStyle", "filterPlaceholder", "filterFields", "emptyFilterMessage"])
  ], 64))
})